(() => {
  const init = () => document.querySelectorAll('.js6v2-catalog').forEach(root => {
    if (root.dataset.catalogReady) return;
    root.dataset.catalogReady = 'true';
    const current = new URL(location.href);
    const pathParts = current.pathname.split('/');
    const oldTags = pathParts[pathParts.length - 1].split('+');
    const newTags = oldTags.filter(tag => !/^capacity-/.test(tag));
    if (newTags.length !== oldTags.length) {
      if (newTags.length) pathParts[pathParts.length - 1] = newTags.join('+'); else pathParts.pop();
      current.pathname = pathParts.join('/');
      current.searchParams.delete('page');
      location.replace(current.href);
      return;
    }
    const form = root.querySelector('[data-js6v2-filter-form]');
    const sort = root.querySelector('[data-js6v2-sort]');
    sort?.addEventListener('change', () => {
      const url = new URL(location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      location.assign(url.href);
    });
    root.querySelectorAll('[data-js6v2-tag-link], .js6v2-active-filters[aria-label="Selected filters"] a').forEach(link => {
      // Shopify's remove-tag links and our group links retain native price/sort selections.
      const url = new URL(link.href);
      current.searchParams.forEach((value, key) => {
        if ((key.startsWith('filter.') || key === 'sort_by') && !url.searchParams.has(key)) {
          url.searchParams.append(key, value);
        }
      });
      link.href = url.href;
    });
    root.querySelectorAll('[data-js6-budget-min]').forEach(link => {
      const url = new URL(current.href);
      url.searchParams.delete('page');
      url.searchParams.delete('filter.v.price.gte');
      url.searchParams.delete('filter.v.price.lte');
      if (link.dataset.js6BudgetMin) url.searchParams.set('filter.v.price.gte', link.dataset.js6BudgetMin);
      if (link.dataset.js6BudgetMax) url.searchParams.set('filter.v.price.lte', link.dataset.js6BudgetMax);
      link.href = url.href;
    });
    const panel = root.querySelector('.js6v2-filter-panel');
    const groups = [];
    root.querySelectorAll('.js6v2-tag-filter, .js6v2-native-filter').forEach((fieldset, index) => {
      const legend = fieldset.querySelector('legend');
      const details = document.createElement('details');
      details.className = 'js6v2-filter-group';
      details.name = 'js6-filters-' + form.id;
      const summary = document.createElement('summary');
      const title = document.createElement('span');
      title.textContent = legend.textContent;
      const selected = document.createElement('small');
      selected.className = 'js6v2-filter-selection';
      summary.append(title, selected);
      fieldset.before(details);
      details.append(summary, fieldset);
      legend.classList.add('visually-hidden');
      const refresh = () => {
        const link = fieldset.querySelector('a.is-selected');
        const count = fieldset.querySelectorAll('input:checked').length;
        const prices = [...fieldset.querySelectorAll('input[type="number"]')].filter(input => input.value);
        selected.textContent = link ? link.textContent : count ? String(count) : prices.length ? prices.map(input => input.value).join(' – ') : '';
      };
      refresh();
      fieldset.addEventListener('change', refresh);
      details.addEventListener('toggle', () => {
        if (details.open) groups.forEach(group => { if (group !== details) group.open = false; });
      });
      groups.push(details);
      fieldset.querySelectorAll('a').forEach(link => {
        link.addEventListener('click', event => {
          if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button) return;
          event.preventDefault();
          fieldset.querySelectorAll('a').forEach(option => {
            option.classList.toggle('is-selected', option === link);
            if (option === link) option.setAttribute('aria-current', 'true'); else option.removeAttribute('aria-current');
          });
          if (fieldset.dataset.filterGroup === 'budget') {
            pendingBudget = true;
            form.querySelectorAll('input[name="filter.v.price.gte"], input[name="filter.v.price.lte"]').forEach(input => {
              input.value = input.name.endsWith('gte') ? link.dataset.js6BudgetMin : link.dataset.js6BudgetMax;
              input.dispatchEvent(new Event('change', { bubbles: true }));
            });
          }
          refresh();
          form.requestSubmit();
        });
      });
    });
    let pendingBudget = false;
    form.addEventListener('submit', event => {
      event.preventDefault();
      const invalid = [...form.elements].find(input => input.willValidate && !input.validity.valid);
      if (invalid) { invalid.closest('details').open = true; invalid.reportValidity(); return; }
      const minimum = form.querySelector('[name="filter.v.price.gte"]');
      const maximum = form.querySelector('[name="filter.v.price.lte"]');
      if (minimum?.value && maximum?.value && Number(minimum.value) > Number(maximum.value)) {
        [minimum.value, maximum.value] = [maximum.value, minimum.value];
      }
      const url = new URL(current.href);
      const base = form.dataset.collectionUrl.replace(/\/$/, '');
      let tags = current.pathname.startsWith(base + '/') ? current.pathname.slice(base.length + 1).split('+') : [];
      root.querySelectorAll('[data-filter-group]:not([data-filter-group="budget"])').forEach(group => {
        const prefix = group.dataset.filterGroup;
        tags = tags.filter(tag => !decodeURIComponent(tag).startsWith(prefix));
        const selected = group.querySelector('a.is-selected');
        if (!selected) return;
        const selectedTags = new URL(selected.href).pathname.split('/').pop().split('+');
        const tag = selectedTags.find(value => decodeURIComponent(value).startsWith(prefix));
        if (tag) tags.push(tag);
      });
      url.pathname = base + (tags.length ? '/' + [...new Set(tags)].join('+') : '');
      url.searchParams.delete('page');
      const names = new Set([...form.elements].map(input => input.name).filter(Boolean));
      names.forEach(name => url.searchParams.delete(name));
      for (const [name, value] of new FormData(form)) if (value !== '') url.searchParams.append(name, value);
      if (pendingBudget && !names.has('filter.v.price.gte')) {
        const selected = root.querySelector('[data-filter-group="budget"] a.is-selected');
        url.searchParams.delete('filter.v.price.gte');
        url.searchParams.delete('filter.v.price.lte');
        if (selected.dataset.js6BudgetMin) url.searchParams.set('filter.v.price.gte', selected.dataset.js6BudgetMin);
        if (selected.dataset.js6BudgetMax) url.searchParams.set('filter.v.price.lte', selected.dataset.js6BudgetMax);
      }
      const applyButton = root.querySelector('.js6v2-filter-actions button');
      if (applyButton) { applyButton.textContent = 'Applying filters…'; applyButton.disabled = true; }
      root.querySelector('.js6v2-catalog__results')?.setAttribute('aria-busy', 'true');
      location.assign(url.href);
    });
    if (matchMedia('(max-width:1100px)').matches) panel.open = false;
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

